/*
 * Copyright (c) 2026. Tooling Team
 */

export const LOINC_LONG_COMMON_NAME_COLUMN_KEY = "loincConceptDescription";

export const LOINC_OPTIONS_LIMIT = 100;

// MAPPED, WONT_MAP, NEEDS_REVIEW
export const MAPPING_STATUS_OPTIONS = [
  { value: "MAPPED", label: "MAPPED" },
  { value: "WONT_MAP", label: "WONT_MAP" },
  { value: "NEEDS_REVIEW", label: "NEEDS_REVIEW" },
];

export const LOCAL_CODE_COLUMN_KEY_PREFIX = "local";
export const ML_PROBABILITY_COLUMN_KEY = "mlProbability";
export const MAPPING_STATUS_COLUMN_KEY = "status";
export const USER_COMMENTS_COLUMN_KEY = "userComments";
export const PRODUCT_USAGE_COLUMN_KEY = "productUsage";

export const PRODUCT_USAGE_FILTER_OPTIONS = [
  { value: "VC", label: "VC" },
  { value: "LS", label: "LS" },
  { value: "CAI", label: "CAI" },
];
